import { useUserMetadataQueryContext } from '../contexts/UserMetadataQueryContext';
import { useUserKey } from './useUserKey';

export const useUserDisplayName = (showUserKey = true) => {
  const userKey = useUserKey(true);
  const { emailAddress, externalUserId } = useUserMetadataQueryContext();
  const displayUserKey = showUserKey ? externalUserId || userKey : undefined;

  return emailAddress || displayUserKey;
};
